import { MissionType } from '../../lib/types/models/mission-type/mission-type'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getMissionType(id: number) {
  return restApiClient.url(constructApiUrl(API.missionTypes.get.url, { id })).get<MissionType>()
}
